import React from "react";
export default function LOWER() {
  return <div>Excel_LOWER</div>;
}
